import { Injectable } from '@angular/core';
import { ColDef, IDateFilterParams } from 'ag-grid-community';
import { right } from '@popperjs/core';
import { dblclickTooltipDef, defaultColumn, grid_widths_map } from '@piqet-angular/shared';
import { MyOrganizationFacade } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class PaymentTransactionDataGridService {
  event: any;
  invoiceData = new Subject<[any, any, any]>();
  invoiceObservable$ = this.invoiceData.asObservable();
  constructor(
    private myOrganizationFacade: MyOrganizationFacade,
    private myOrganizationService: MyOrganizationService,
    private spinnerService: NgxSpinnerService,
    private route: Router
  ) {}
  paymentTransactionPayload: any;

  getPaymentTransactionDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'TransactionId',
      headerName: 'Transaction id',
      field: 'transactionId',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const activeRoute = this.route.url.split('/')[2];
          this.invoiceData.next([params.data, 'Invoice', activeRoute]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'SubscriptionId',
      headerName: 'Subscription id',
      field: 'subscriptionId',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Amount',
      headerName: 'Amount',
      field: 'amount',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agNumberColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PaymentMethod',
      headerName: 'Payment method',
      field: 'paymentMethod',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'DateString',
      headerName: 'Date',
      field: 'dateString',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agDateColumnFilter',
      // filterParams: this.filterParams,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Status',
      headerName: 'Status',
      field: 'status',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ErrorText',
      headerName: 'Error message',
      field: 'errorText',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellClass: 'my-permission-cursor-pointer',
      minWidth: grid_widths_map.sm_column_xs,
      maxWidth: grid_widths_map.sm_column_xs,
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showInvoice: true,
        invoiceLable: 'View invoice',
        invoiceData: (data: any, pathName: any) => {
          this.invoiceData.next([data, 'Invoice', pathName]);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getPaymentTransactionDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.paymentTransactionPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'transactionId',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getNewProcessColumns() {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'CustomerName',
      headerName: 'Customer name',
      field: 'customerName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'InvoiceId',
      headerName: 'Invoice id',
      field: 'invoiceId',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      sortable: false,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'AppliedAmount',
      headerName: 'Amount',
      field: 'appliedAmount',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      sortable: false,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'AppliedAt',
      headerName: 'Created on',
      field: 'appliedAt',
      cellClass: 'truncated-text',
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      wrapText: true,
      autoHeight: true,
      sortable: false,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'InvoiceDate',
      headerName: 'Date',
      field: 'invoiceDate',
      cellClass: 'truncated-text',
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      wrapText: true,
      autoHeight: true,
      sortable: false,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'InvoiceStatus',
      headerName: 'Status',
      field: 'invoiceStatus',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      sortable: false,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'InvoiceTotal',
      headerName: 'Invoice total',
      field: 'invoiceTotal',
      valueFormatter: this.currencyFormatter,
      sortable: false,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        invoiceDownload: true,
        invoiceLable: 'Attachments',
        invoiceDownloadData: (data: any) => {
          this.downloadInvoice(data.invoiceId);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  downloadInvoice(invoiceId: any) {
    this.myOrganizationService.invoiceDownloadData(invoiceId).subscribe({
      next: (res: any) => {
        if (res.messageType === 0 && res.data && res.data.pdfURL) {
          window.open(res.data.pdfURL);
        } else {
          console.error('Error downloading invoice:', res.message || 'Invalid response data');
        }
      },
      error: error => {
        console.error('Error downloading invoice:', error);
      },
    });
  }
  currencyFormatter(params: any) {
    // Format the value as desired
    const formattedValue = `${params.value} USD`;
    return formattedValue;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
}
